import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 16px;
  animation: fadeInOverlay 0.2s ease-out;

  @keyframes fadeInOverlay {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 920px;
  height: 85vh;
  max-height: 720px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: scaleUpModal 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes scaleUpModal {
    from {
      transform: scale(0.96) translateY(8px);
      opacity: 0;
    }
    to {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
`;

export const HeaderTitleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ModalTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemCounterBadge = styled.span`
  background: #f1f5f9;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.15s ease;

  &:hover {
    background: #f1f5f9;
    color: #0f172a;
  }
`;

export const TabsNav = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 24px;
  border-bottom: 1px solid #eef2f6;
  background: #f8fafc;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  background: transparent;
  border: none;
  padding: 12px 16px;
  font-size: 0.875rem;
  font-weight: ${({ $active }) => ($active ? '700' : '500')};
  color: ${({ $active }) => ($active ? '#2563eb' : '#64748b')};
  border-bottom: 2px solid ${({ $active }) => ($active ? '#2563eb' : 'transparent')};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.15s ease;

  &:hover {
    color: ${({ $active }) => ($active ? '#2563eb' : '#0f172a')};
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-wrap: wrap;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 12px;
  height: 38px;
  width: 280px;
  transition: all 0.15s ease;

  &:focus-within {
    border-color: #2563eb;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  svg {
    color: #94a3b8;
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

export const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.85rem;
  width: 100%;
  color: #1e293b;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const FilterChips = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  overflow-x: auto;
`;

export const ChipButton = styled.button<{ $active: boolean }>`
  background: ${({ $active }) => ($active ? '#eff6ff' : '#f8fafc')};
  color: ${({ $active }) => ($active ? '#2563eb' : '#475569')};
  border: 1px solid ${({ $active }) => ($active ? '#bfdbfe' : '#e2e8f0')};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ $active }) => ($active ? '#dbeafe' : '#f1f5f9')};
  }
`;

export const SortSelect = styled.select`
  height: 38px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0 10px;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #2563eb;
  }
`;

export const GalleryContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
`;

export const FilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
`;

export const FileCard = styled.div<{ $selected: boolean }>`
  border: 2px solid ${({ $selected }) => ($selected ? '#2563eb' : '#e2e8f0')};
  background: ${({ $selected }) => ($selected ? '#f8faff' : '#ffffff')};
  border-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  position: relative;
  transition: all 0.15s ease;
  user-select: none;

  &:hover {
    border-color: ${({ $selected }) => ($selected ? '#1d4ed8' : '#cbd5e1')};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

export const SelectionBadge = styled.div<{ $selected: boolean }>`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${({ $selected }) => ($selected ? '#2563eb' : 'rgba(255, 255, 255, 0.85)')};
  border: 1px solid ${({ $selected }) => ($selected ? '#2563eb' : '#cbd5e1')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  z-index: 2;
  transition: all 0.15s ease;
`;

export const ThumbnailWrapper = styled.div`
  width: 100%;
  height: 105px;
  background: #f8fafc;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FileIconPlaceholder = styled.div<{ $type?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${({ $type }) => {
    if ($type === 'pdf') return '#dc2626';
    if ($type === 'sheet') return '#16a34a';
    if ($type === 'doc') return '#2563eb';
    return '#64748b';
  }};

  span {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FileName = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileMeta = styled.span`
  font-size: 0.7rem;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EmptyState = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
  padding: 40px;
  text-align: center;

  svg {
    color: #cbd5e1;
  }

  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #475569;
  }

  p {
    margin: 0;
    font-size: 0.82rem;
    max-width: 320px;
  }
`;

export const UploadDropzone = styled.div<{ $isDragOver: boolean }>`
  border: 2px dashed ${({ $isDragOver }) => ($isDragOver ? '#2563eb' : '#cbd5e1')};
  background: ${({ $isDragOver }) => ($isDragOver ? '#eff6ff' : '#f8fafc')};
  border-radius: 12px;
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 24px;
  text-align: center;

  &:hover {
    border-color: #2563eb;
    background: #eff6ff;
  }
`;

export const UploadIconCircle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
`;

export const UploadTitle = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const UploadSubtitle = styled.p`
  font-size: 0.8rem;
  color: #64748b;
  margin: 0;
`;

export const UploadFormArea = styled.div`
  padding: 0 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InputLabel = styled.label`
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
`;

export const CustomTitleInput = styled.input`
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 0.85rem;
  outline: none;
  transition: all 0.15s ease;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-top: 1px solid #eef2f6;
  background: #ffffff;
`;

export const PaginationArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.8rem;
  color: #64748b;
`;

export const PageButton = styled.button<{ disabled?: boolean }>`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }
`;

export const ActionsArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CancelButton = styled.button`
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #f1f5f9;
  }
`;

export const ConfirmButton = styled.button<{ disabled?: boolean }>`
  background: #2563eb;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #ffffff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: #1d4ed8;
  }
`;

export const CardMenuButton = styled.button`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  cursor: pointer;
  z-index: 3;
  transition: all 0.15s ease;
  font-size: 14px;
  line-height: 1;

  &:hover {
    background: #ffffff;
    color: #2563eb;
    border-color: #2563eb;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const ZoomBadge = styled.div`
  position: absolute;
  bottom: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 2;

  ${ThumbnailWrapper}:hover & {
    opacity: 1;
  }
`;

export const UsageModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  padding: 16px;
`;

export const UsageModalContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

export const UsageModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
`;

export const UsageModalTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UsageModalBody = styled.div`
  padding: 16px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const UsageItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

export const UsageItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
`;

export const UsageModuleBadge = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const UsageRecordName = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UsageRecordLink = styled.a`
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.15s ease;

  &:hover {
    color: #2563eb;
    text-decoration: underline;
  }
`;

export const UsageItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const UsageLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: #2563eb;
    color: #ffffff;
    border-color: #2563eb;
    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
  }
`;

export const UsageCoverBadge = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  color: #b45309;
  background: #fef3c7;
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
`;

export const UsageEmpty = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: #64748b;
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const CardMenuDropdown = styled.div`
  position: absolute;
  top: 36px;
  left: 8px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 4px;
  min-width: 140px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 2px;
  animation: fadeInMenu 0.15s ease-out;

  @keyframes fadeInMenu {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const CardMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #334155;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all 0.1s ease;

  &:hover {
    background: #f1f5f9;
    color: #2563eb;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const EditModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  padding: 16px;
`;

export const EditModalContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 440px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

export const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
`;

export const EditModalTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EditModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EditModalLabel = styled.label`
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
`;

export const EditModalInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 0.88rem;
  color: #1e293b;
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

export const EditModalFooter = styled.div`
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: #f8fafc;
`;

